import * as React from "react"
const TextFileIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#999"
      strokeWidth={2}
      d="m1.595 10.357 8.898-8.78A2 2 0 0 1 11.898 1H28a3 3 0 0 1 3 3v32a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V11.78a2 2 0 0 1 .595-1.423Z"
    />
    <path stroke="#999" strokeWidth={2} d="M11 2v9a1 1 0 0 1-1 1H2" />
    <rect width={15} height={1} x={8.5} y={18.5} stroke="#999" rx={0.5} />
    <rect width={15} height={1} x={8.5} y={26.5} stroke="#999" rx={0.5} />
    <rect width={15} height={1} x={8.5} y={22.5} stroke="#999" rx={0.5} />
    <rect width={11} height={1} x={8.5} y={30.5} stroke="#999" rx={0.5} />
  </svg>
)
export default TextFileIcon
